import React, { Component } from "react"
import { Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import { Button, Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import Dropzone from "react-dropzone"
import ido from "idexo-sdk"

const apiKey = "YsqBLMOEWR48QRiKVt2CR4eU89oDK5zQa0Ib6c29"
const apiKey1 = "yNbIZOVLk51eMqd6cT4CJ2KLJ28VManN6UOOVIhX"

class MintNFT extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedFiles: [],
            name: "",
            description: "",
            attributes: [{ name: "", value: "" }],
            mintToAdress: "",
            network: "bsc"
        }
    }

    handleAcceptedFiles = async (files) => {
        const toBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () =>
                    resolve(
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                            formattedSize: this.formatBytes(file.size),
                            base64: reader.result.split(",")[1]
                            // base64: reader.result
                        })
                    )
                reader.onerror = (error) => reject(error)
            })

        const base64Files = await Promise.all(
            files.map((file) => {
                return toBase64(file)
            })
        )

        this.setState({ selectedFiles: base64Files })
    }

    handleSubmit = async (event) => {
        event.preventDefault()
        const attributes = {}
        this.state.attributes.forEach((attribute) => {
            attributes[attribute.name] = attribute.value
        })

        if (this.state.selectedFiles.length === 0 || this.state.selectedFiles[0].base64 === undefined) {
            alert("Please upload NFT image")
            return
        }
        if (this.state.network === "bsc") {
            const result = await ido.React.mintBEP721(
                "0x6bd3a139ebad80fc95deeda14688b061971a415f",
                this.state.mintToAdress,
                this.state.selectedFiles[0].base64,
                this.state.selectedFiles[0].type,
                this.state.name,
                this.state.description,
                attributes,
                apiKey1
            )

            const { data, status, statusText } = result

            if (status === 200) {
                alert(`NFT successfully minted. Address is: ${data}`)
            } else {
                alert(`Minting NFT failed. StatusCode: ${status}. Reason: ${statusText}`)
            }
        }
    }

    sendMint = (name, description, attributes, image) => {
        // param: contractAddress, addressToMintTo, imagepath, nftName, nftDescription, apiKey, attributes
        // ido.Multi.mintNFTBscAr(
        //   contractAddress,
        //   name,
        //   description,
        //   attributes,
        //   apiKey
        // );
    }

    formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <MetaTags>
                        <title>Mint NFT</title>
                    </MetaTags>

                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">Mint NFT</CardTitle>
                                    <p className="card-title-desc">
                                        Provide a name, description and media file for your NFT
                                    </p>

                                    <AvForm onValidSubmit={this.handleSubmit}>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup className="mb-3">
                                                    <AvField
                                                        name="nftname"
                                                        label="Name"
                                                        className="form-control"
                                                        placeholder="Enter NFT Name"
                                                        type="text"
                                                        onChange={(e) => this.setState({ name: e.target.value })}
                                                        required
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mb-3">
                                                    <AvField
                                                        name="metadescription"
                                                        label="Description"
                                                        className="form-control"
                                                        placeholder="Description"
                                                        type="textarea"
                                                        onChange={(e) => this.setState({ description: e.target.value })}
                                                        rows="5"
                                                        required
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mb-3">
                                                    <Row>
                                                        <Col sm="6">
                                                            <Label htmlFor="attribute1_name">Attribute Name</Label>
                                                            {this.state.attributes.map((attribute, index) => {
                                                                return (
                                                                    <Input
                                                                        key={`attribute${index}_name`}
                                                                        id={`attribute${index}_name`}
                                                                        name={`attribute${index}_name`}
                                                                        type="text"
                                                                        className="form-control mb-1"
                                                                        onChange={(e) => {
                                                                            const temp = this.state.attributes
                                                                            temp[index].name = e.target.value
                                                                            this.setState({ attributes: temp })
                                                                        }}
                                                                        value={attribute.name}
                                                                    />
                                                                )
                                                            })}
                                                        </Col>
                                                        <Col sm="6">
                                                            <Label htmlFor="attribute1_value">Value</Label>
                                                            {this.state.attributes.map((attribute, index) => {
                                                                return (
                                                                    <Input
                                                                        key={`attribute${index}_value`}
                                                                        id={`attribute${index}_value`}
                                                                        name={`attribute${index}_value`}
                                                                        type="text"
                                                                        className="form-control  mb-1"
                                                                        onChange={(e) => {
                                                                            const temp = this.state.attributes
                                                                            temp[index].value = e.target.value
                                                                            this.setState({ attributes: temp })
                                                                        }}
                                                                        value={attribute.value}
                                                                    />
                                                                )
                                                            })}
                                                        </Col>
                                                    </Row>
                                                    <Input
                                                        id="nftname"
                                                        name="nftname"
                                                        type="button"
                                                        value="+"
                                                        onClick={() => {
                                                            this.setState({
                                                                attributes: [
                                                                    ...this.state.attributes,
                                                                    { name: "", value: "" }
                                                                ]
                                                            })
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="control-label">Network</Label>
                                                    <select
                                                        className="form-control select2"
                                                        value={this.state.network}
                                                        onChange={(e) => {
                                                            this.setState({ network: e.target.value })
                                                        }}
                                                    >
                                                        <option>Select</option>
                                                        <option value="eth">Ethereum Mainnet</option>
                                                        <option value="bsc">Binance Smart Chain</option>
                                                    </select>
                                                </FormGroup>
                                                <FormGroup className="mb-3">
                                                    <Label className="control-label">Collection</Label>
                                                    <select className="form-control select2">
                                                        <option>Select</option>
                                                        <option value="0x48e98966d3bd0c4f842eca562b375a7d5d2af340">
                                                            BSC - 0x48e98966d3bd0c4f842eca562b375a7d5d2af340
                                                        </option>
                                                    </select>
                                                </FormGroup>
                                                <FormGroup className="mb-3">
                                                    <AvField
                                                        name="mintoaddress"
                                                        label="Mint To Address"
                                                        className="form-control"
                                                        placeholder="Enter Mint To Address"
                                                        type="text"
                                                        onChange={(e) =>
                                                            this.setState({ mintToAdress: e.target.value })
                                                        }
                                                        required
                                                    />
                                                </FormGroup>
                                                <Form className="dropzone">
                                                    <Dropzone
                                                        onDrop={(acceptedFiles) =>
                                                            this.handleAcceptedFiles(acceptedFiles)
                                                        }
                                                        maxFiles={1}
                                                    >
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div>
                                                                <div
                                                                    className="dz-message needsclick"
                                                                    {...getRootProps()}
                                                                >
                                                                    <input {...getInputProps()} />
                                                                    <div className="dz-message needsclick">
                                                                        <div className="mb-3">
                                                                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                                        </div>
                                                                        <h4>Drop files here or click to upload.</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                    <div className="dropzone-previews mt-3" id="file-previews">
                                                        {this.state.selectedFiles.map((f, i) => {
                                                            return (
                                                                <Card
                                                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                                    key={i + "-file"}
                                                                >
                                                                    <div className="p-2">
                                                                        <Row className="align-items-center">
                                                                            <Col className="col-auto">
                                                                                <img
                                                                                    data-dz-thumbnail=""
                                                                                    height="80"
                                                                                    className="avatar-sm rounded bg-light"
                                                                                    alt={f.name}
                                                                                    src={f.preview}
                                                                                />
                                                                            </Col>
                                                                            <Col>
                                                                                <Link
                                                                                    to="#"
                                                                                    className="text-muted font-weight-bold"
                                                                                >
                                                                                    {f.name}
                                                                                </Link>
                                                                                <p className="mb-0">
                                                                                    <strong>{f.formattedSize}</strong>
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Card>
                                                            )
                                                        })}
                                                    </div>
                                                </Form>
                                            </Col>
                                        </Row>
                                        <div className="d-flex flex-wrap gap-2">
                                            <Button type="submit" color="primary" className="waves-effect waves-light">
                                                Mint
                                            </Button>
                                            <Button
                                                type="submit"
                                                color="secondary"
                                                className="waves-effect waves-light"
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default MintNFT
